export default __webpack_public_path__ + "static/media/partyPopper.3e12f5f1.svg";